

/* ══════════════════════════════════════════════════════════════════
   SISTEMA DE DESIGN — "Bay"
   Grafite de bancada, listra Gulf, tipografia de sinalização.
   ══════════════════════════════════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&family=Barlow+Condensed:wght@500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap');

.of{
  --ink:#171C22; --ink2:#212A33; --ink3:#2E3945;
  --floor:#ECEEF1; --card:#FFFFFF; --el:#F5F7F8;
  --line:#DCE1E6; --line2:#C6CED6;
  --txt:#171C22; --mut:#697987; --mut2:#8D9AA6;
  --gulf:#4FAFD1; --gulf-d:#2C7E9C; --gulf-l:#E3F2F8;
  --signal:#E2620C; --signal-l:#FDEFE3;
  --ok:#137A56; --ok-l:#E4F4EE;
  --warn:#A8630A; --warn-l:#FCF1DF;
  --crit:#BC3227; --crit-l:#FBE9E7;
  --r:6px;
  font-family:'Barlow',system-ui,sans-serif;
  color:var(--txt); background:var(--floor);
  -webkit-font-smoothing:antialiased;
}
.of *{box-sizing:border-box;}
.dsp{font-family:'Barlow Condensed','Barlow',sans-serif;text-transform:uppercase;letter-spacing:.045em;font-weight:600;line-height:1.05;}
.mono{font-family:'IBM Plex Mono',ui-monospace,monospace;font-variant-numeric:tabular-nums;}
.eyebrow{font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;letter-spacing:.13em;font-weight:600;font-size:11px;color:var(--mut);}

.t-mut{color:var(--mut);} .t-mut2{color:var(--mut2);} .t-ink{color:var(--ink);}
.t-signal{color:var(--signal);} .t-ok{color:var(--ok);} .t-crit{color:var(--crit);}
.t-warn{color:var(--warn);} .t-gulf{color:var(--gulf-d);}
.bg-el{background:var(--el);} .bg-card{background:var(--card);}
.brd{border:1px solid var(--line);}
.card{background:var(--card);border:1px solid var(--line);border-radius:var(--r);}

/* listra dupla — livery */
.stripe{height:3px;display:flex;border-radius:2px 2px 0 0;overflow:hidden;}
.stripe i{display:block;height:100%;}
.stripe i:nth-child(1){background:var(--signal);width:38%;}
.stripe i:nth-child(2){background:var(--gulf);width:62%;}

/* placa mercosul */
.plate{display:inline-flex;flex-direction:column;background:#fff;border:1.5px solid #10161C;border-radius:4px;overflow:hidden;line-height:1;vertical-align:middle;flex:none;}
.plate-top{background:#0B3B8C;color:#fff;font-family:'Barlow Condensed',sans-serif;letter-spacing:.18em;text-align:center;font-weight:600;}
.plate-num{font-family:'IBM Plex Mono',monospace;font-weight:600;color:#10161C;text-align:center;letter-spacing:.04em;}
.plate-sm .plate-top{font-size:6px;padding:1.5px 0;} .plate-sm .plate-num{font-size:12px;padding:2px 7px 3px;}
.plate-md .plate-top{font-size:8px;padding:2px 0;} .plate-md .plate-num{font-size:17px;padding:3px 11px 5px;}
.plate-lg .plate-top{font-size:10px;padding:3px 0;} .plate-lg .plate-num{font-size:24px;padding:5px 16px 7px;}

/* botões */
.btn{display:inline-flex;align-items:center;justify-content:center;gap:7px;border-radius:var(--r);
  font-family:'Barlow',sans-serif;font-weight:600;font-size:13.5px;padding:8px 14px;border:1px solid transparent;
  cursor:pointer;transition:background .13s,border-color .13s,color .13s,transform .06s;white-space:nowrap;}
.btn:active{transform:translateY(1px);}
.btn:focus-visible{outline:2px solid var(--gulf);outline-offset:2px;}
.btn:disabled{opacity:.45;cursor:not-allowed;}
.btn-p{background:var(--ink);color:#fff;} .btn-p:hover:not(:disabled){background:var(--ink3);}
.btn-s{background:var(--signal);color:#fff;} .btn-s:hover:not(:disabled){background:#C9560B;}
.btn-o{background:var(--card);color:var(--ink);border-color:var(--line2);} .btn-o:hover:not(:disabled){background:var(--el);border-color:var(--mut2);}
.btn-g{background:transparent;color:var(--mut);} .btn-g:hover:not(:disabled){background:var(--el);color:var(--ink);}
.btn-ok{background:var(--ok);color:#fff;} .btn-ok:hover:not(:disabled){background:#0F6247;}
.btn-x{background:var(--card);color:var(--crit);border-color:var(--line2);} .btn-x:hover:not(:disabled){background:var(--crit-l);border-color:var(--crit);}
.btn-xs{padding:4px 9px;font-size:12px;gap:5px;} .btn-lg{padding:11px 20px;font-size:15px;}

/* campos */
.inp{width:100%;background:var(--card);border:1px solid var(--line2);border-radius:var(--r);
  padding:8px 11px;font-size:14px;font-family:'Barlow',sans-serif;color:var(--txt);transition:border-color .13s,box-shadow .13s;}
.inp:focus{outline:none;border-color:var(--gulf-d);box-shadow:0 0 0 3px var(--gulf-l);}
.inp::placeholder{color:var(--mut2);}
.inp-mono{font-family:'IBM Plex Mono',monospace;}
select.inp{appearance:none;background-image:linear-gradient(45deg,transparent 50%,#697987 50%),linear-gradient(135deg,#697987 50%,transparent 50%);
  background-position:calc(100% - 15px) 55%,calc(100% - 10px) 55%;background-size:5px 5px,5px 5px;background-repeat:no-repeat;padding-right:30px;}
.lbl{display:block;font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;letter-spacing:.1em;font-size:11px;font-weight:600;color:var(--mut);margin-bottom:5px;}

/* pills */
.pill{display:inline-flex;align-items:center;gap:5px;border-radius:3px;padding:2.5px 8px;font-size:11.5px;font-weight:600;
  font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;letter-spacing:.07em;border:1px solid transparent;}
.p-ok{background:var(--ok-l);color:var(--ok);border-color:#BFE3D6;}
.p-warn{background:var(--warn-l);color:var(--warn);border-color:#EDD9B4;}
.p-crit{background:var(--crit-l);color:var(--crit);border-color:#F1C9C5;}
.p-info{background:var(--gulf-l);color:var(--gulf-d);border-color:#BEE0EC;}
.p-sig{background:var(--signal-l);color:var(--signal);border-color:#F6D3B6;}
.p-mut{background:var(--el);color:var(--mut);border-color:var(--line);}

/* tabela */
.tbl{width:100%;border-collapse:collapse;font-size:14px;}
.tbl th{font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;letter-spacing:.1em;font-size:11px;
  font-weight:600;color:var(--mut);text-align:left;padding:9px 12px;border-bottom:1px solid var(--line);background:var(--el);white-space:nowrap;}
.tbl td{padding:10px 12px;border-bottom:1px solid var(--line);vertical-align:middle;}
.tbl tbody tr{transition:background .1s;}
.tbl tbody tr:hover{background:var(--el);}
.tbl .num{text-align:right;font-family:'IBM Plex Mono',monospace;font-variant-numeric:tabular-nums;}

/* navegação */
.nav-i{display:flex;align-items:center;gap:11px;padding:9px 14px 9px 11px;border-left:3px solid transparent;
  color:#9AA9B6;font-size:14px;font-weight:500;cursor:pointer;transition:background .13s,color .13s,border-color .13s;width:100%;text-align:left;background:none;border-top:none;border-right:none;border-bottom:none;}
.nav-i:hover{background:var(--ink2);color:#E6EDF2;}
.nav-i.on{background:var(--ink2);color:#fff;border-left-color:var(--signal);}
.nav-i.on .nav-dot{background:var(--gulf);}
.nav-dot{width:5px;height:5px;border-radius:50%;background:transparent;margin-left:auto;}

/* modal */
.ovl{position:fixed;inset:0;background:rgba(15,20,25,.55);backdrop-filter:blur(2px);z-index:60;display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto;}
.mdl{background:var(--card);border-radius:8px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.28);margin:auto 0;animation:rise .16s ease-out;}
@keyframes rise{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:none;}}
@keyframes fade{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}
.rise{animation:rise .18s ease-out;} .fade{animation:fade .22s ease-out both;}

/* diversos */
.bar{height:5px;background:var(--line);border-radius:3px;overflow:hidden;}
.bar i{display:block;height:100%;border-radius:3px;}
.grid-bg{background-image:linear-gradient(rgba(255,255,255,.035) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.035) 1px,transparent 1px);background-size:34px 34px;}
.tab{padding:9px 14px;font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;letter-spacing:.08em;font-size:13px;font-weight:600;
  color:var(--mut);border-bottom:2px solid transparent;cursor:pointer;background:none;border-top:none;border-left:none;border-right:none;white-space:nowrap;transition:color .13s,border-color .13s;}
.tab:hover{color:var(--ink);} .tab.on{color:var(--ink);border-bottom-color:var(--signal);}
.mic-ring{position:relative;}
.mic-ring::after{content:'';position:absolute;inset:-10px;border-radius:50%;border:2px solid var(--signal);opacity:0;animation:ping 1.4s ease-out infinite;}
@keyframes ping{0%{transform:scale(.85);opacity:.7;}100%{transform:scale(1.35);opacity:0;}}
.scroll::-webkit-scrollbar{width:9px;height:9px;}
.scroll::-webkit-scrollbar-thumb{background:var(--line2);border-radius:5px;}
.scroll::-webkit-scrollbar-track{background:transparent;}
.sem{width:30px;height:30px;border-radius:5px;border:1px solid var(--line2);background:var(--card);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .12s;}
.sem.on-ok{background:var(--ok);border-color:var(--ok);color:#fff;}
.sem.on-warn{background:var(--warn);border-color:var(--warn);color:#fff;}
.sem.on-crit{background:var(--crit);border-color:var(--crit);color:#fff;}
/**
 * A barra lateral em classe, não em estilo inline.
 *
 * Estas propriedades estavam no atributo style do aside no App.tsx, e estilo
 * inline vence media query — sempre, não importa a especificidade da regra.
 * Resultado: no celular a barra continuava sticky e com 232px reservados no
 * fluxo. Ela saía da vista pelo transform, mas o espaço dela ficava: num
 * aparelho de 390px sobravam 158px para o conteúdo, e a tela inteira
 * aparecia espremida e torta.
 *
 * (Sem crase nestes comentários: o arquivo inteiro é um template literal, e
 * uma crase solta aqui encerra a string e quebra o build.)
 *
 * Com as propriedades aqui, a regra de celular mais abaixo consegue mandar.
 */
/**
 * Item de grade encolhe.
 *
 * Por padrão todo item de grade tem min-width:auto, que quer dizer "nunca
 * menor que o próprio conteúdo". As telas aninham grades: um .grid por fora
 * e, dentro, outro com repeat(auto-fit,minmax(190px,1fr)). Num celular a
 * grade de dentro pedia dois trilhos de 190px, a de fora obedecia, e o
 * conjunto ficava com 581px dentro de um espaço de 342px.
 *
 * O pior era o efeito: a página não rolava de lado, então o que passava da
 * borda ficava simplesmente inalcançável. Não era layout feio — era conteúdo
 * escondido.
 *
 * Só grade, de propósito. A mesma regra em .flex deixaria botão encolher
 * abaixo do próprio texto, e botão com white-space:nowrap encolhido corta a
 * palavra no meio.
 */
.of .grid > *{min-width:0;}

/* Régua da OS: onde ela está, sem precisar ler os botões. Seis etapas numa
   tela de 390px só cabem quebrando linha, e quebrar é melhor que rolar de
   lado — isto se olha de relance, no meio do serviço. */
.of-regua{display:flex;flex-wrap:wrap;gap:5px;align-items:center;margin-bottom:12px;}
.of-etapa{
  font-size:11px; line-height:1; padding:5px 9px; border-radius:999px;
  border:1px solid var(--line); color:var(--mut); white-space:nowrap;
}
.of-etapa.passou{color:var(--ok);border-color:var(--ok);}
.of-etapa.agora{background:var(--signal);border-color:var(--signal);color:#fff;font-weight:600;}

.of-lado{
  width:232px; flex:none; display:flex; flex-direction:column;
  background:var(--ink); position:sticky; top:0; height:100vh; z-index:50;
}

.btn-menu{display:none;}
.of-veu{display:none;}
@media (max-width:900px){
  /* position:fixed tira a barra do fluxo: sem isto ela some da vista pelo transform
     mas continua ocupando 232px, e o conteúdo fica no que sobra. */
  .of-lado{position:fixed;left:0;top:0;height:100vh;transform:translateX(-100%);transition:transform .2s ease;}
  /* A sombra só quando a gaveta está aberta. Fechada, ela vazava uma faixa
     escura na borda esquerda da tela. */
  .of-lado[data-menu="true"]{transform:translateX(0);box-shadow:0 0 44px rgba(0,0,0,.42);}
  .btn-menu{display:inline-flex;}
  .of-veu[data-menu="true"]{display:block;position:fixed;inset:0;background:rgba(15,20,25,.5);z-index:45;}
  .of main{padding:16px!important;}
}
@media (prefers-reduced-motion:reduce){.of *{animation:none!important;transition:none!important;}}
/* ══════════════════════════════════════════════════════════════════
   IMPRESSÃO
   O diálogo do navegador já oferece "Salvar como PDF", então imprimir e
   gerar PDF são a mesma ação — sem biblioteca, sem peso no pacote.

   visibility em vez de display: esconder por display quebraria o
   layout dos ancestrais e a folha sairia deslocada na página.
   ══════════════════════════════════════════════════════════════════ */
.folha{display:none;}

@media print{
  @page{margin:14mm;}
  body *{visibility:hidden;}
  .folha,.folha *{visibility:visible;}
  .folha{display:block;position:absolute;left:0;top:0;width:100%;
    font-family:'Barlow',sans-serif;color:#000;background:#fff;font-size:11pt;}

  /* Fundo escuro e sombra gastam tinta e não comunicam nada no papel. */
  .folha *{box-shadow:none !important;}
  .folha .fh{display:flex;justify-content:space-between;align-items:flex-start;
    border-bottom:2px solid #000;padding-bottom:8pt;margin-bottom:12pt;}
  .folha .fh-nome{font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;
    font-weight:700;font-size:17pt;line-height:1.05;letter-spacing:.01em;}
  .folha .fh-dados{font-size:8.5pt;line-height:1.45;margin-top:2pt;}
  .folha .fh-doc{text-align:right;}
  .folha .fh-doc .t{font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;
    font-weight:700;font-size:13pt;}
  .folha .fh-doc .n{font-family:'IBM Plex Mono',monospace;font-size:15pt;font-weight:600;}

  .folha h2{font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;
    font-size:10pt;letter-spacing:.09em;margin:12pt 0 4pt;border-bottom:1px solid #999;
    padding-bottom:2pt;}
  .folha .par{display:grid;grid-template-columns:1fr 1fr;gap:2pt 16pt;font-size:10pt;}
  .folha .par b{font-weight:600;}

  .folha table{width:100%;border-collapse:collapse;font-size:10pt;margin-top:3pt;}
  .folha th{text-align:left;border-bottom:1px solid #000;padding:3pt 4pt;
    font-family:'Barlow Condensed',sans-serif;text-transform:uppercase;font-size:8.5pt;
    letter-spacing:.06em;}
  .folha td{padding:3pt 4pt;border-bottom:1px solid #DDD;vertical-align:top;}
  .folha td.n,.folha th.n{text-align:right;font-variant-numeric:tabular-nums;
    font-family:'IBM Plex Mono',monospace;}
  /* Cabeçalho repete em cada página quando a lista de itens passa de uma. */
  .folha thead{display:table-header-group;}
  .folha tr{break-inside:avoid;}

  .folha .tot{margin-top:8pt;margin-left:auto;width:52%;font-size:10.5pt;}
  .folha .tot div{display:flex;justify-content:space-between;padding:2pt 0;}
  .folha .tot .g{border-top:2px solid #000;margin-top:3pt;padding-top:4pt;
    font-weight:700;font-size:13pt;}

  .folha .ass{margin-top:26pt;display:grid;grid-template-columns:1fr 1fr;gap:26pt;
    break-inside:avoid;}
  .folha .ass div{border-top:1px solid #000;padding-top:3pt;font-size:8.5pt;text-align:center;}
  .folha .rodape{margin-top:14pt;padding-top:5pt;border-top:1px solid #CCC;
    font-size:8pt;line-height:1.4;}
  .folha .obs{font-size:9.5pt;white-space:pre-wrap;}
}

`;

export { CSS };
